// Adresse de l'API. En production : toujours https://joli-mot.fr. Pour tester en local contre
// `php -S localhost:8000 -t public`, créer un fichier .env.development.local (jamais commité, lu
// uniquement par `npm start`) contenant :  REACT_APP_API_BASE=http://localhost:8000
// On ne met donc JAMAIS d'adresse locale dans le code.
export const API_BASE = process.env.REACT_APP_API_BASE || 'https://joli-mot.fr';

// Clé publique de l'API (déjà présente partout dans le site). Ce n'est PAS un secret : tout ce
// qui est sensible est protégé côté serveur par le mot de passe d'administration.
export const CLE_API = '34KVHFQSP226YTk4n256QP6rGbqhA5w2ymY7W3pLwdbuc3i75';

export const apiUrl = (service) => `${API_BASE}/api-2026.php?cleApi=${CLE_API}&service=${service}`;
